// extracted by mini-css-extract-plugin
export default {"item":"style_item__6jOfT","preview":"style_preview__0XIxj","date":"style_date__fMui0","open":"style_open__QKnSO","detailsContent":"style_detailsContent__U7C70"};